import { InputFieldProps } from './logic';
import { KeyboardEvent } from 'react';

type Action = 'noop' | 'prevent' | 'back';

export function checkInputMask(
  event: KeyboardEvent<HTMLInputElement>,
  value: string | undefined,
  textMask?: string | RegExp,
  readonly?: boolean,
  pattern?: string
): Action {
  if (readonly || !textMask) {
    return 'noop';
  }
  if (!textMask && !pattern) {
    return 'noop';
  }

  if (['Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].indexOf(event.key) > -1)
    return 'noop';

  const prevValue = value || '';

  if ((textMask && typeof prevValue === 'string') || pattern) {
    if (event.code === 'Backspace') {
      return 'back';
    }

    const regex = textMask
      ? new RegExp(getTextMaskValue(textMask as string))
      : pattern
      ? new RegExp(pattern)
      : undefined;

    if (
      !regex?.test(event.key) ||
      (textMask &&
        (event.currentTarget.value?.length || 0) >= (textMask as string).length)
    ) {
      return 'prevent';
    }
  }
  return 'noop';
}

const maskCharToRegexMap: Record<string, string> = {
  '#': '\\d',
  '&': '[A-Za-z]',
  '*': '[A-Za-z\\d]'
};

export const getTextMask = (textMask: InputFieldProps['textMask']) => {
  if (!textMask) return undefined;
  if (typeof textMask === 'string') return textMask;
  if (typeof textMask[0] === 'object') {
    return new RegExp(textMask[0]).source;
  }
  return textMask[0];
};

export const getTextMaskValue = (textMask: string) => {
  return textMask
    .split('')
    .map((t) => `(${maskCharToRegexMap[t] || t})`)
    .join('|');
};
